import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        // 奖励结果页
        {
            path: '/award',
            name: 'award',
            component: () => import('@/pages/award.vue')
        },
        // 完成页
        {
            path: '/finish',
            name: 'finish',
            component: () => import('@/pages/finish.vue')
        },
        // main
        {
            path: '/main',
            name: 'main',
            component: () => import('@/pages/main.vue')
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js